import stampit from 'stampit'

const Utterance = stampit({
  props: {
    pitch: 1,
    rate: 1,
    delay: 0,
    text: '',
    audio: null
  },
  init ({pitch, rate, delay, text, audio, ttsDuration}) {
    this.pitch = pitch || this.pitch
    this.rate = rate || this.rate
    this.delay = delay || this.delay
    this.text = text || this.text
    if (audio) {
      this.audio = audio
    }
    if (ttsDuration) {
      this.ttsDuration = ttsDuration
    }

    // this.name = name || this.name;
    // this.specials = specials || this.specials;
  },
  methods: {
    getProcessedText () {
      // The following is also implemented on the server before generating premium tts
      // This makes it more consistent and (hopfully) doesn't impact results.
      // If we make changes to this code, be sure to update the function code as well.
      var str = this.text
        .toLowerCase() // lower case
        .replace(/[!.,]/g, '') // remove deliminators except ?
        .replace(/\s\s+/g, ' ') // convert multiple spaces into a single space
        .trim() // trim trailing & leading space
      return str
    }
  }
})
export default Utterance



// WEBPACK FOOTER //
// ./src/tts/utterance.js